import { faCalendarDay } from '@fortawesome/free-solid-svg-icons';

import * as S from './styles';

interface IDateBox {
  date: string;
  showDay?: boolean;
}

const DateBox = ({ date, showDay }: IDateBox) => {
  const format: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'short',
    day: showDay ? 'numeric' : undefined
  };

  return (
    <S.DataBox>
      <S.StyledFontAwesomeIcon icon={faCalendarDay} />
      {new Date(date).toLocaleDateString('en-US', format)}
    </S.DataBox>
  );
};

export default DateBox;
